import * as React from 'react';
import { range } from 'lodash';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import Flex from 'ui/Flex/Flex';
import { useGetBlogArticles } from 'routes/Home/hooks/useGetBlogArticles';
import { useTranslation } from 'react-i18next';
import { Theme, useMediaQuery } from '@mui/material';
import BlogArticleCard from './BlogArticleCard';
import BlogArticleCardLoading from './BlogArticleCard.loading';

const StyButton = styled(Button, {
    name: 'StyButton',
})(() => ({
    padding: '4px 8px',
}));

const BlogArticles = (): JSX.Element => {
    const { data: blogArticles, isLoading } = useGetBlogArticles();

    const { t } = useTranslation();

    const isSmallScreen = useMediaQuery<Theme>((theme) =>
        theme.breakpoints.down('lg'),
    );

    const maxArticles = isSmallScreen ? 2 : 5;

    return (
        <Flex direction="column" align="center">
            <Flex align="center" justify="space-between" sx={{ width: '100%' }}>
                <Typography variant="h5">{t('home.blog.title')}</Typography>
                <StyButton
                    color="primary"
                    href="https://www.manty.eu/blog"
                    style={{ border: '1px solid' }}
                    variant="outlined"
                    endIcon={<ChevronRightIcon />}
                >
                    {t('home.blog.seeMore')}
                </StyButton>
            </Flex>
            <Flex
                direction="row"
                justify="space-between"
                align="start"
                sx={{ mt: '20px', width: '100%', gap: 2 }}
            >
                {isLoading &&
                    range(maxArticles).map((number) => (
                        <BlogArticleCardLoading key={number} />
                    ))}
                {blogArticles
                    ?.slice(0, maxArticles)
                    .map((blogArticle) => (
                        <BlogArticleCard
                            blogArticle={blogArticle}
                            key={blogArticle.slug}
                        />
                    ))}
            </Flex>
        </Flex>
    );
};

export default BlogArticles;
